import { ErrorHandler, Injectable } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private sentryHandler: Sentry.SentryErrorHandler;

    constructor(private _toastService: ToastService, private router: Router) {
        this.sentryHandler = Sentry.createErrorHandler({
            showDialog: false
        });
    }
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [^\s]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            const toast = this._toastService.show({
                intent: 'info',
                title: '🚀 New version available!',
                message: `The app will reload and update shortly.`,
                actions: {
                    primary: 'Update now'
                },
                duration: 5 * 1000
            });
            const time = Date.now();
            // after the toast is dismissed/closed...
            toast.afterDismissed().subscribe((_) => {
                // ...force a reload of the login page
                // TODO: will need to be refactored once we remove the environment from the path
                const baseHref = window.location.pathname.split('/')[1];
                const currentUrl = btoa(this.router.url);
                window.location.href = `${window.location.origin}/${baseHref}/login?t=${time}&reason=newVersion&resume=${currentUrl}`;
            });
            return; // do not log this error to Sentry
        }
        // For all other errors, use Sentry handler
        this.sentryHandler.handleError(error);
    }
}
